module.exports = __webpack_public_path__ + "static/media/pin.3a47d4f8.svg";